export default {
  collectorManagerApi: {
    source: {
      drivers: '/api/collector/source/drivers',
      getList: '/api/collector/source/getList',
      state: '/api/collector/source/state',
      terminate: '/api/collector/source/terminate',
      control: '/api/collector/source/control',
      getDetail: '/api/collector/source/getDetail',
      synchro: '/api/collector/source/synchro'
    },
    resfulDriver: {
      restfulInfoSaveOrUpdate: '/api/restfulDriver/restfulInfoSaveOrUpdate',
      getMetricList: '/api/restfulDriver/getMetricList',
      importMetrics: '/api/restfulDriver/importMetrics',
      exportTemp: '/api/restfulDriver/exportTemp',
      metricSaveOrUpdate: '/api/restfulDriver/metricSave',
      metricsDel: '/api/restfulDriver/metricsDel'
    },
    modbusdriver: {
      saveOrUpdateModbusSource: 'api/modbusdriver/saveOrUpdateModbusSource',
      getMetricList: '/api/modbusdriver/getMetricList',
      importMetrics: '/api/modbusdriver/importMetrics',
      exportTemp: '/api/modbusdriver/exportTemp',
      metricSaveOrUpdate: '/api/modbusdriver/metricSave',
      metricsDel: '/api/modbusdriver/metricsDel'
    },
    opcDriver: {
      saveOrUpdateOpcSource: 'api/opcDriver/saveOrUpdateOpcSource',
      getMetricList: '/api/opcDriver/getMetricList',
      importMetrics: '/api/opcDriver/importMetrics',
      exportTemp: '/api/opcDriver/exportTemp',
      metricSaveOrUpdate: '/api/opcDriver/metricSave',
      metricsDel: '/api/opcDriver/metricsDel'
    },
    edcDriver: {
      saveOrUpdateEdcSource: 'api/edcDriver/saveOrUpdateEdcSource',
      getMetricList: '/api/edcDriver/getMetricList',
      importMetrics: '/api/edcDriver/importMetrics',
      exportTemp: '/api/edcDriver/exportTemp',
      metricSaveOrUpdate: '/api/edcDriver/metricSave',
      metricsDel: '/api/edcDriver/metricsDel'
    },
    BACnetDriver: {
      saveOrUpdateBACnetSource: 'api/BACnetDriver/saveOrUpdateBACnetSource',
      getMetricList: '/api/BACnetDriver/getMetricList',
      importMetrics: '/api/BACnetDriver/importMetrics',
      exportTemp: '/api/BACnetDriver/exportTemp',
      supportObjectType: '/api/BACnetDriver/supportObjectType',
      metricSaveOrUpdate: '/api/BACnetDriver/metricSave',
      metricsDel: '/api/BACnetDriver/metricsDel'
    },
    sqlRtDriver: {
      sqlTypes: '/api/sqlRtDriver/sqlTypes',
      sqlRtSaveOrUpdate: 'api/sqlRtDriver/sqlRtSaveOrUpdate',
      getTagList: '/api/sqlRtDriver/getTagList',
      getTables: '/api/sqlRtDriver/getTables',
      getColumns: '/api/sqlRtDriver/getColumns',
      tagSaveOrUpdate: '/api/sqlRtDriver/tagSaveOrUpdate',
      retransmission: '/api/sqlRtDriver/retransmission',
      tagDels: '/api/sqlRtDriver/tagDels',
      getMetricList: '/api/sqlRtDriver/getMetricList',
      metricsDel: '/api/sqlRtDriver/metricsDel',
      metricUpdate: '/api/sqlRtDriver/metricUpdate',
    },
    sqlToSqlDriver: {
      sqlToSqlSaveOrUpdate: 'api/sqlToSqlDriver/sqlToSqlSaveOrUpdate',
      sqlTypes: '/api/sqlToSqlDriver/sqlTypes',
      getDataBases: 'api/sqlToSqlDriver/getDataBases',
      saveOrUpdateDataBase: 'api/sqlToSqlDriver/saveOrUpdateDataBase',
      dataBaseTerminate: 'api/sqlToSqlDriver/dataBaseTerminate',
      getTableKeyList: '/api/sqlToSqlDriver/getTableKeyList',
      tableKeySaveOrUpdate: '/api/sqlToSqlDriver/tableKeySaveOrUpdate',
      tableKeyTerminate: '/api/sqlToSqlDriver/tableKeyTerminate',
      getDataBasesOpt: '/api/sqlToSqlDriver/getDataBasesOpt',
      getDataBaseTables: '/api/sqlToSqlDriver/getDataBaseTables',
      getColumns: '/api/sqlToSqlDriver/getColumns',
      retransmission: '/api/sqlToSqlDriver/retransmission',
      getMetricList: '/api/sqlToSqlDriver/getMetricList',
      metricsDel: '/api/sqlToSqlDriver/metricsDel',
      metricUpdate: '/api/sqlToSqlDriver/metricUpdate',
    },
    tag: {
      getSourceOptions: '/api/collector/tag/getSourceOptions',
      getValueTypeOptions: '/api/collector/tag/getValueTypeOptions',
      getList: '/api/collector/tag/getList',
      getDataPoints: '/api/collector/tag/getDataPoints'
    },
    aberrant: {
      getFilterOptions: 'api/preprocessing/aberrant/getFilterOptions',
      getList: 'api/preprocessing/aberrant/getList',
      getAberrant: 'api/preprocessing/aberrant/getAberrant',
      history: 'api/preprocessing/aberrant/history/getValue'
    }
  }
}